import { Select, SelectProps } from '@shared/Form/Select'
import { always, cond, equals, isNil, propEq, T } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const ChargingPointStatusSelect = (props: SelectProps<any>) => {
  const { onChange, value, ...others } = props

  const { t } = useTranslation()

  const handleOnChange = (value: any, option: any) => {
    if (!onChange) {
      return
    }
    onChange(
      cond<any, Record<string, boolean> | undefined>([
        [isNil, always(undefined)],
        [
          equals('available'),
          always({
            available: true,
          }),
        ],
        [
          equals('charging'),
          always({
            charging: true,
          }),
        ],
        [equals('unavailable'), always({ unavailable: true })],
      ])(value),
      option
    )
  }

  const selectValue = React.useMemo(
    () =>
      cond<any, string | undefined>([
        [isNil, always(undefined)],
        [propEq('available', true), always('available')],
        [propEq('charging', true), always('charging')],
        [propEq('unavailable', true), always('unavailable')],
        [T, always('isAll')],
      ])(value),
    [value]
  )

  return (
    <Select
      placeholder={t('light:deviceStatus')}
      onChange={handleOnChange}
      value={selectValue}
      {...others}>
      <Select.Option value="isAll">全部</Select.Option>
      <Select.Option value="available">可使用</Select.Option>
      <Select.Option value="charging">使用中</Select.Option>
      <Select.Option value="unavailable">無服務</Select.Option>
    </Select>
  )
}

export default ChargingPointStatusSelect
